var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersBarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42105 8.24242C10.7474 8.24242 12.6316 6.39818 12.6316 4.12121C12.6316 1.84424 10.7474 0 8.42105 0C6.09474 0 4.21053 1.84424 4.21053 4.12121C4.21053 6.39818 6.09474 8.24242 8.42105 8.24242ZM8.42105 2.06061C9.57895 2.06061 10.5263 2.98788 10.5263 4.12121C10.5263 5.25455 9.57895 6.18182 8.42105 6.18182C7.26316 6.18182 6.31579 5.25455 6.31579 4.12121C6.31579 2.98788 7.26316 2.06061 8.42105 2.06061ZM2.10526 14.4242C2.31579 13.7752 4.81053 12.6933 7.32632 12.4255L9.47368 10.3648C9.06316 10.3236 8.7579 10.303 8.42105 10.303C5.61053 10.303 0 11.6836 0 14.4242V16.4848H9.47368L7.36842 14.4242H2.10526ZM18.5263 8.75758L13.1263 14.0842L10.9474 11.9412L9.47368 13.3939L13.1263 17L20 10.2103L18.5263 8.75758Z",
    fill: "#A6A6A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersBarIcon);
export default __webpack_public_path__ + "static/media/users-bar-icon.45da5cd70222475ccf87740d06438cfc.svg";
export { ForwardRef as ReactComponent };